<template>
  <div class="container">
    <div class="row spinner">
      <hp-spinner :spinner="spinner" />
    </div>
    <div v-if="isRender">
      <div class="row flex-row-reverse">
        <appDetail-pdf :resourceId="resourceId"></appDetail-pdf>
      </div>
      <div class="row upperArea">
        <div class="col-md-12 col-lg-6 leftArea">
          <div class="d-flex flex-column">
            <app-title
              :app-info-data="appInfoData"
              :back-url="backUrl"
              :uuid="resourceId"
            />

            <div class="body">
              <div class="links" v-if="this.appInfoData.webSite !== ''">
                <div style="align-self: center">
                  {{ this.appInfoData.vendorName }}
                </div>
                <div class="blankWidth10" />
                |<span style="padding-left: 10px" />
                <a
                  :href="appInfoData.webSite"
                  class="solutionSupport"
                  target="_blank"
                >
                  <u>Support</u>
                </a>
                <div
                  v-if="
                    this.appInfoData.marketingDocuments.length > 0 ||
                    this.appInfoData.videoLink !== ''
                  "
                >
                  <div class="blankWidth10" />
                  |<span style="padding-left: 10px; position: relative" />
                </div>
              </div>
              <div class="links" v-else>
                <div
                  style="padding-right: 10px"
                  id="linkVendorName"
                  class="appProviderName"
                >
                  {{ appInfoData.vendorName }}
                </div>
                <div
                  v-if="
                    this.appInfoData.marketingDocuments.length > 0 ||
                    this.appInfoData.videoLink !== ''
                  "
                >
                  <div class="blankWidth10" />
                  |<span style="padding-left: 10px; position: relative" />
                </div>
              </div>
              <div class="links">
                <div v-if="this.appInfoData.marketingDocuments.length > 0">
                  <a
                    :href="appInfoData.marketingDocuments"
                    class="solutionBrief"
                    target="_blank"
                  >
                    <u>Brief</u>
                  </a>
                </div>
                <div
                  v-if="
                    this.appInfoData.marketingDocuments.length > 0 &&
                    this.appInfoData.videoLink !== ''
                  "
                >
                  <div class="blankWidth10" />
                  |<span style="padding-left: 10px; position: relative" />
                </div>

                <div v-if="this.appInfoData.videoLink !== ''">
                  <a
                    :href="appInfoData.videoLink"
                    class="solutionVideo"
                    target="_blank"
                  >
                    <u>Video</u>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-6 right-area">
          <media :slides="slides" />
        </div>
      </div>
      <div class="row">
        <manual
          :app-info-data="appInfoData"
          :support-language-list="supportLanguageList"
          :uuid="resourceId"
          :support-country-list="supportCountryList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Media from "./Media.vue";
import HpSpinner from "../HpSpinner";
import Manual from "./Manual.vue";
import SlideDto from "../../js/SlideDto";
import AppTitle from "./AppTitle.vue";
import ApiSvc from "../../js/ApiSvc";
import AppDetailPdf from "./AppDetailPdf.vue";
import { API, Constants } from "../../js/Constants.js";

export default {
  name: "app-detail",
  components: {
    AppTitle,
    Manual,
    Media,
    HpSpinner,
    AppDetailPdf,
  },
  data() {
    return {
      appInfoData: [],
      supportCountryList: [],
      supportLanguageList: [],
      slides: [],
      backUrl: "/",
      privacyLinkData: null,
      spinner: 0,
      isRender: false,
      youtubeId: null,
      resourceId: this.$route.params.id,
    };
  },
  created() {
    this.loadDetailData();
  },
  methods: {
    loadDetailData() {
      this.supportLanguageList = [];
      this.supportCountryList = [];
      this.supportBriefUrls = [];
      this.slides = [];
      this.spinner++;
      this.isRender = false;
      ApiSvc.request(
        ["/appinfos/${id}/appinfodetails", [this.resourceId]],
        API.GET
      )
        .then((res) => res.data)
        .then((res) => {
          if (res.marketingDocuments == null) {
            res.marketingDocuments = [];
          }
          if (res.videoLink == null) {
            res.videoLink = "";
          }
          this.appInfoData = res;
          this.setLanguageData();
          this.setCountryData();
          if (this.appInfoData.resourceUrInfolList[0].video != null) {
            let slideDto = new SlideDto();
            slideDto.type = "Video";
            this.youtubeIdName(this.appInfoData.resourceUrInfolList[0].video);
            slideDto.image =
              "https://img.youtube.com/vi/" + this.youtubeId + "/mqdefault.jpg";
            slideDto.url = "https://www.youtube.com/embed/" + this.youtubeId;
            this.slides.push(slideDto);
          }
          res.resourceUrInfolList.forEach((item) => {
            let slideDto = new SlideDto();
            slideDto.type = "Image";
            slideDto.url = item.url;
            this.slides.push(slideDto);
          });
          this.fillSlides(); // If there are no more images, the blank image will be filled
          this.spinner--;
          this.isRender = true;
        });
    },
    setLanguageData() {
      this.appInfoData.supportedLocaleSet.map((item) => {
        let data = Constants.LOCALE_LANG_MAP[item];
        this.supportLanguageList.push(data);
      });
    },
    setCountryData() {
      this.appInfoData.countryCodes.forEach((value) => {
        this.supportCountryList.push(value);
      });
    },
    fillSlides() {
      for (let index = this.slides.length; index < 5; index++) {
        let slideDto = new SlideDto();
        slideDto.type = "Blank";
        slideDto.url = " ";
        this.slides.push(slideDto);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/hpCustom.scss";
@import "../../styles/hpConstant.scss";
@import "../../styles/hpMixin.scss";
@import "../../styles/hpModule.scss";

.spinner {
  position: fixed;
  z-index: 1031;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.upperArea {
  .leftArea {
    .body {
      font-family: "FormaDJR";
      margin-right: 20%;
      line-height: 1.5rem;
      font-size: 1rem;
      display: flex;
      align-self: center;
      .links {
        display: flex;
        flex-direction: row;
        justify-content: center;
        padding-top: 1rem;

        .solutionSupport {
          color: $hpLightBlue;
          cursor: pointer;
          float: left;
          padding-right: 10px;
        }
        .solutionBrief {
          color: $hpLightBlue;
          cursor: pointer;
          float: left;
          padding-right: 10px;
        }
        .solutionVideo {
          color: $hpLightBlue;
          cursor: pointer;
          float: left;
        }

        .blankWidth10 {
          @include blankWidth(10px);
        }
      }

      .textLink {
        cursor: pointer;
        color: $hpLightBlue;
        text-decoration: underline;
      }

      .licenseType {
        margin: 5px 0;
      }

      .chargeInfo::before {
        content: "*";
        margin-left: 5px;
        color: $hpLightRed;
      }

      .chargeInfo {
        font-size: 14px;
      }

      .helpImage {
        margin-top: 10px;

        img {
          margin-left: 8px;
        }
        img:hover {
          cursor: pointer;
        }
      }
      .subscribeButton {
        line-height: 20px;
        margin-top: 16px;
        word-break: break-all;
        color: $hpLightBlue;
        font-size: 20px;
        font-weight: bold;

        .hpBlueButton {
          min-width: 90px;
        }
      }

      .buttonArea {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-top: 28px;
        word-break: break-all;
        color: $hpLightBlue;
        font-size: 20px;
        font-weight: bold;
        line-height: 20px;

        .subscribedButton {
          margin: 0 20px 14px 0;
          float: left;
        }

        .removeSolution:hover .tooltip {
          display: block;
        }

        .tooltip {
          position: relative;
          color: $hpBlack;
          margin-top: -30px;
          margin-left: 25px;
          display: none;
        }
      }
    }
  }
}
</style>
